(function () {
  const wrappers = document.querySelectorAll('.section-featured-product');

  wrappers.forEach((wrapper) => {
    const trigger = wrapper.querySelector('[data-description-trigger]');
    const drawer = wrapper.querySelector('[data-description-drawer]');
    const overlay = wrapper.querySelector('[data-drawer-overlay]');
    const closeBtn = wrapper.querySelector('[data-drawer-close]');
    const addCartBtn = wrapper.querySelector('[data-compact-add-cart]');
    const qtyDisplay = wrapper.querySelector('[data-compact-qty]');
    const soldOutText = wrapper.querySelector('[data-compact-sold-out-hidden]');
    const priceEl = wrapper.querySelector('[data-compact-price]');

    if (!trigger || !drawer) return;

    /* ---------- Drawer ---------- */
    const openDrawer = () => {
      drawer.classList.add('is-open');
      overlay?.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      overlay?.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    /* ---------- Add to Cart ---------- */
    if (addCartBtn) {
      addCartBtn.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }]
          })
        })
          .then(() => {
            if (qtyDisplay) {
              qtyDisplay.textContent =
                (parseInt(qtyDisplay.textContent) || 0) + 1;
            }
            this.disabled = false;
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(() => {
            this.disabled = false;
          });
      });
    }

    /* ---------- Variant Change ---------- */
    document.addEventListener('variant:changed', (e) => {
      const variant = e.detail.variant;
      if (!variant || !addCartBtn) return;

      addCartBtn.dataset.variantId = variant.id;

      if (variant.available) {
        addCartBtn.disabled = false;
        soldOutText && (soldOutText.style.display = 'none');
      } else {
        addCartBtn.disabled = true;
        soldOutText && (soldOutText.style.display = 'block');
      }

      if (priceEl && variant.price) {
        priceEl.innerHTML =
          Shopify.formatMoney(
            variant.price,
            window.theme?.moneyFormat || '{{ shop.money_format }}'
          ) + '{{ block.settings.price_suffix }}';
      }
    });
  });
})();
